import React from 'react';
import helloLogo from '@assets/logos/hello-my-name-is-logo-web.png';
import '../styles.scss';

interface PreferredNameProps {
  residentFullName: string;
  preferredName: string;
  setPreferredName: React.Dispatch<React.SetStateAction<string>>;
}

const PreferredName: React.FC<PreferredNameProps> = ({
  residentFullName,
  preferredName,
  setPreferredName,
}) => {
  return (
    <div className="mt-10 govuk-bp:mt-14">
      <h1 className="govuk-heading-xl custom-title">
        {residentFullName} - About me & What Matters Most
      </h1>
      <img className="hello-logo" src={helloLogo} alt={helloLogo} width={230} />
      <h1 className="govuk-heading-l">Preferred name</h1>
      <div className="govuk-form-group mt-10 govuk-bp:mt-14">
        <h3 className="govuk-label-wrapper">
          <label
            className="govuk-label govuk-label--s"
            htmlFor="full-name-input"
          >
            What name do you like to be called by?
          </label>
        </h3>

        <div className="govuk-hint" id="full-name-hint">
          The name by which a person wishes to be addressed. The preferred name
          volunteered by the person or a preferred name given by PDS that the
          person has asked to be called by.
        </div>
        <input
          className="govuk-input govuk-input--width-20"
          id="full-name-input"
          name="preferredName"
          type="text"
          autoComplete="preferredName"
          placeholder="Enter the name you prefer to be called by here"
          value={preferredName ?? ''}
          onChange={e => setPreferredName(e.target.value)}
        />
      </div>
    </div>
  );
};

export default PreferredName;
